<template>
  <ul class="invoice-list">
    <li v-for="({ invoice_number }, index) in bundledInvoices"
        :key="index"
        class="downloadable-invoice"
        @click="downloadInvoice">
      <span>Factuur</span>
      <span class="invoice-number">{{ invoice_number }}</span>
    </li>
  </ul>

</template>
<script lang="ts" setup>
import { useInvoice } from '@pidz/stores';
import { openFile } from '@pidz/utils';
import { FilteredBundleInvoice } from '../types';

const props = defineProps<{
  bundledInvoices: FilteredBundleInvoice[];
  invoiceId: number;
  invoiceType: 'freelancer' | 'software';
}>();

const invoiceStore = useInvoice();

const downloadInvoice = async () => {
  const downloadFunction = 
    props.invoiceType === 'freelancer'
      ? invoiceStore.downloadFreelancerInvoice
      : invoiceStore.downloadSoftwareInvoice;
  const file =  await downloadFunction(props.invoiceId);
  openFile(file)
};
</script>
<style lang="scss">
.invoice-list {
  display: block;
  position: absolute;
  background: var(--pidz-white);
  z-index: 1;
  box-shadow: var(--shadow-light);
  border-radius: 2px;
  right: 0;
  top: 0;
  padding: 12px 16px;
  color: var(--pidz-body-text);
  min-width: 120px;

  ul {
    left: 0;
    margin: 0;
    padding: 0;
  }

  .downloadable-invoice {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    padding: 2px;

    span.invoice-number {
      font-size: 12px;
      color: var(--pidz-grey-dark);
      margin-top: 2px;
    }
  }
}
</style>
